export const addMinutesToDate = (date: Date, minutes: number): Date => {
  const time = new Date(date).getTime();
  return new Date(time + minutes * 60000);
};
